import GoogleFontClient from '../services/GoogleFontClient.js';

const fontList = ["Alegreya Sans", "Amatica SC", "Amiko",
    "Arima Madurai", "Arvo", "Baloo", "Bree Serif", "Bungee", "Bungee Shade",
    "Coming Soon", "Cookie", "Cormorant", "Cormorant SC", "Cormorant Upright",
    "Crimson Text", "Cuprum", "Dancing Script", "Domine", "Dosis", "Droid Sans",
    "Droid Serif", "Gloria Hallelujah", "Gravitas One", "Great Vibes", "Gudea",
    "Hind", "Indie Flower", "Josefin Sans", "Julius Sans One", "Lalezar",
    "Libre Baskerville", "Lora", "Luckiest Guy", "Monoton", "Noticia Text", "Nunito",
    "Open Sans", {label:"Open Sans Condensed", value:"Open Sans Condensed", weights:[300]}, "Pacifico", "Play", "Playball", "Poiret One",
    "Pontano Sans", "Quicksand", "Raleway", "Rokkitt", "Sacramento", "Sanchez", "Scope One",
    "Shadows Into Light", "Six Caps", "Space Mono", "Special Elite", "Work Sans",
    "Aldrich", "Alegreya", "Alex Brush", "Alice", "Alike",
    "Alegreya Sans SC", "Allerta Stencil", "Amaranth", "Amatic SC",
    "Amethysta", "Amiri", "Andada", "Anton", "Arbutus Slab", "Archivo Black",
    "Belgrano", "Berkshire Swash", "BioRhyme", "Black Ops One",
    "Boogaloo", "Bubblegum Sans", "Butterfly Kids", "Cabin", "Cardo",
    "Clicker Script", "Comfortaa", "Contrail One", "Copse", "Coustard",
    "Didact Gothic", "EB Garamond", "Exo", "Fanwood Text", "Fauna One",
    "Fjalla One", "Francois One", "Gabriela", "Gochi Hand", "Halant",
    "Hammersmith One", "Handlee", "Headland One", "Holtwood One SC",
    "IM Fell English SC", "Jaldi", "Josefin Slab", "Jura", "Just Another Hand",
    "Kameron", "Karma", "Kreon", "Lato", "Lobster", "Lusitana", "Lustria",
    "Marmelad", "Martel", "Mate", "Merriweather", "Montserrat", "Oranienbaum",
    "Oswald", "Overlock", "Pangolin", "Pathway Gothic One", "Peddana",
    "Permanent Marker", "Pinyon Script", "Playfair Display", "Poppins",
    "Pragati Narrow", "PT Sans", "Radley", "Rajdhani", "Rasa", "Roboto",
    "Roboto Condensed", "Roboto Slab", "Rochester", "Rocksalt", "Rubik",
    "Russo One", "Sansita", "Shrikhand", "Sigmar One", "Signika",
    "Slabo 13px", "Sofia", "Source Code Pro", "Source Sans Pro",
    "Source Serif Pro", "Sue Ellen Francisco", "Suez One", "Teko",
    "Trocchi", "Ultra", "Varela Round", "Viga", "Vollkorn",
    "Muli", "Neuton", "Cormorant Garamond", "Abril Fatface",
    "Ubuntu", "PT Serif", "Old Standard TT"];

export const WEB_LOAD_FONT_LIST = fontList.map( f => typeof f === 'string' ? { label: f, value: f} : f).sort(sortByLabel);

export const CSS_SAFE_FONTS = [
    {
        label: 'Georgia',
        value: 'Georgia, serif'
    },
    {
        label: 'Platino',
        value: '"Palatino Linotype", "Book Antiqua", Palatino, serif'
    },
    {
        label: 'Times New Roman',
        value: '"Times New Roman", Times, serif'
    },
    {
        label: 'Arial',
        value: 'Arial, Helvetica, sans-serif'
    },
    {
        label: 'Comic Sans',
        value: '"Comic Sans MS", cursive, sans-serif'
    },
    {
        label: 'Impact',
        value: 'Impact, Charcoal, sans-serif'
    },
    {
        label: 'Lucida Sans',
        value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif'
    },
    {
        label: 'Tahoma',
        value: 'Tahoma, Geneva, sans-serif'
    },
    {
        label: 'Trebuchet',
        value: '"Trebuchet MS", Helvetica, sans-serif'
    },
    {
        label: 'Verdana',
        value: 'Verdana, Geneva, sans-serif'
    },
    {
        label: 'Monospace',
        value: 'Monospace Fonts'
    },
    {
        label: 'Courier',
        value: '"Courier New", Courier, monospace'
    },
    {
        label: 'Lucida Console',
        value: '"Lucida Console", Monaco, monospace'
    }];


function sortByLabel(a,b) {
    if (a.label === b.label) return 0;
    return a.label > b.label ? 1 : -1;
}

export const ALL_GOOGLE_FONTS_LIST = new GoogleFontClient()
  .getFontList()
  .then( fonts => fonts.items.filter( item => !WEB_LOAD_FONT_LIST.find( font => font.label === item.family)));

export const PREFERRED_FONTS_LIST = [{
    label:'Web Safe fonts',
    value: '_separator'
}].concat(CSS_SAFE_FONTS.sort(sortByLabel)).concat([{
    label:'Featured Web Fonts',
    value: '_separator'
}]).concat(WEB_LOAD_FONT_LIST)
    .concat([{
    label:'More Web Fonts',
    value: '_separator'
}]);



// WEBPACK FOOTER //
// ./src/constants/Fonts.js